import { Card } from '@heroui/react';
import { useNavigate } from 'react-router';
import { hostRuntime } from '@/core';

export function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-wrap justify-center items-center gap-6">
      {hostRuntime
        .getApps()
        .filter(
          app =>
            app.description.isVisible(app.runtime) &&
            app.navigation().isVisible &&
            app.navigation().items.some(x => x.isVisible),
        )
        .map(app => (
          <Card
            key={app.id}
            render={domProps => <button type="button" {...domProps} />}
            className="hover:cursor-pointer hover:outline-1 outline-accent w-1/6 text-left"
            onClick={() => navigate(app.baseUrl + app.description.defaultRoute)}
          >
            <Card.Header className="justify-between">
              <div className="flex items-center justify-center size-12 rounded-xl bg-accent-soft">
                <i className={`text-2xl text-accent ${app.description.iconClass}`} />
              </div>
            </Card.Header>
            <Card.Content className="pt-0">
              <Card.Title className="text-lg">{app.description.title}</Card.Title>
            </Card.Content>
            <Card.Footer className="justify-start">
              <div className="flex items-center gap-2">
                <span>Open</span>
                <i className="text-sm ri-arrow-right-line" />
              </div>
            </Card.Footer>
          </Card>
        ))}
    </div>
  );
}
